import { render, staticRenderFns } from "./SwContactSetting.vue?vue&type=template&id=bac0a1ee&scoped=true"
import script from "./SwContactSetting.vue?vue&type=script&lang=js"
export * from "./SwContactSetting.vue?vue&type=script&lang=js"
import style0 from "./SwContactSetting.vue?vue&type=style&index=0&id=bac0a1ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bac0a1ee",
  null
  
)

export default component.exports